'use client';

import {
  SnackbarProvider as OriginalSnackbarProvider,
  closeSnackbar as originalCloseSnackbar,
  enqueueSnackbar as originalEnqueueSnackbar,
} from 'notistack';
import { type ReactNode } from 'react';

import { MultiplyIcon } from '@/components/icons';
import { IconButton } from '@/primitives';

export function enqueueSnackbar(
  message: ReactNode,
  options?: Parameters<typeof originalEnqueueSnackbar>[1],
) {
  if (options?.variant === 'error') {
    options = {
      autoHideDuration: 20000,
      action: (key) => (
        <>
          <IconButton
            color="inherit"
            onClick={() => originalCloseSnackbar(key)}
          >
            <MultiplyIcon />
          </IconButton>
        </>
      ),
      ...options,
    };
  }
  return originalEnqueueSnackbar(message, options);
}

export const closeSnackbar = originalCloseSnackbar;

export interface SnackbarProviderProps {
  children: ReactNode;
}

export function SnackbarProvider({ children }: SnackbarProviderProps) {
  return (
    <OriginalSnackbarProvider
      anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
    >
      {children}
    </OriginalSnackbarProvider>
  );
}
